<script setup lang="ts">
import AdminAwardsStats from "./AdminAwardsStats.vue";
import AdminAwardsMgmt from "./AdminAwardsMgmt.vue";
</script>

<template>
  <div class="flex flex-col gap-x-4 gap-y-4 lg:flex-row">
    <AdminAwardsStats />
    <AdminAwardsMgmt />
  </div>
</template>
